import Layout from './Layout';
import NavBar from 'comps/NavBar';
import styles from './styles/MobileLayout.module.scss';
import MinNav from 'comps/MinNav';
import { PullRefresh } from 'react-vant';
import GlobalRefresh from './utils/GlobalRefresh';
import { useEffect } from 'react';

const MobileLayout = ({ title, keywords, description, children }) => {
  const { layoutProps = {} } = children.type || {};

  useEffect(() => {
    return () => {
      GlobalRefresh.removeDependencie();
    };
  }, []);

  const ContainerEle = (
    <div className={styles.mine}>
      <NavBar
        text={title}
        styles={{ borderBottom: 'none', height: '44px' }}
        rightComp={<MinNav />}
      />

      {children}
    </div>
  );

  return (
    <Layout header={null} footer={null} title={title} keywords={keywords} description={description}>
      {layoutProps.onRefresh ? (
        <PullRefresh onRefresh={GlobalRefresh.triggerDependencies}>{ContainerEle}</PullRefresh>
      ) : (
        ContainerEle
      )}
    </Layout>
  );
};
export default MobileLayout;
